import { RING_GAP } from "./place";
import type { Rect } from "./types";

/**
 * The ring. Position and radius follow the target; the pulse child remounts
 * per arrival so it plays once each time the ring lands somewhere new. A
 * target against the window's edge (the header's corner buttons, the pane's
 * full-width views) would put part of the ring off screen, so the ring keeps
 * itself inside the window: the gap gives way on that side, the ring stays
 * whole.
 */
export function TargetRing({
  rect,
  arrival,
}: {
  rect: Rect | null;
  arrival: number;
}) {
  if (!rect) return null;
  const top = Math.max(rect.top - RING_GAP, 0);
  const left = Math.max(rect.left - RING_GAP, 0);
  const bottom = Math.min(
    rect.top + rect.height + RING_GAP,
    window.innerHeight,
  );
  const right = Math.min(rect.left + rect.width + RING_GAP, window.innerWidth);
  return (
    <div
      className="cm-ring"
      aria-hidden="true"
      style={{
        top,
        left,
        width: right - left,
        height: bottom - top,
        borderRadius: Math.max(rect.radius + RING_GAP, RING_GAP),
      }}
    >
      <span key={arrival} className="cm-ring-pulse" />
    </div>
  );
}
